import { render, staticRenderFns } from "./FieldText.vue?vue&type=template&id=72ca991d"
import script from "./FieldText.vue?vue&type=script&lang=js"
export * from "./FieldText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports